export const worldMap = {
  reset: "reset",
  resetMapSelections: "Restablecer las selecciones de mapas",
  zoomIn: "Aumentar o zoom",
  zoomOut: "Diminuir",
  indicatorPanel: {
    indicatorPanelTitle: "O estado atual da Saúde Digital em todo o mundo ",
    noHealthIndicatorAvailable: "Não há indicadores de saúde disponíveis",
    noDigitalIndicatorAvailable:
      "Não há indicadores de saúde global disponíveis",
    viewCountries: "Ver Países",
    viewDetails: "Ver detalhes",
    context: {
      text: "Contexto",
      gniPerCapita: "RNB per capita, método de atlas (US$ corrente)",
      totalPopulation: "População total",
      adultLiteracyRate:
        "Taxa de alfabetização de adultos, população 15+ anos, ambos os sexos (%)",
      easeOfDoingBusinessIndex: "Índice de facilidade de negócios",
    },
    health: {
      text: "Saúde",
      lifeExpectancy: "Esperança de vida à nascença (anos)",
      healthExpenditure: "Despesas de saúde (% do PIB)",
      causeOfDeath:
        "Causa da morte, por doenças não transmissíveis (% do total)",
      mortalityRate:
        "Taxa de mortalidade, menores de 5 anos (por 1,000 nados vivos)",
    },
    description:
      "O Monitor de saúde digital global (GDHM) ou Índice Global de Saúde Digital é um recurso interativo baseado na web, que " +
      "pretende acompanhar, monitorizar e avaliar um ambiente que seja propício à saúde digital em todo o mundo.",
  },
  searchCountry: "Pesquisar País",
  note: "Feito com Terra Natural.",
  note1: "Fronteiras da Índia",
  note2: "por",
  note3: "Comunidade DataMeet Índia",
};
